export default __webpack_public_path__ + "images/View_of_Upper_Limb.f02f9c798d1d3f6ef6884eca38a5cafe.png";